import { useEffect } from 'react'

/** Set page title, using env `VITE_APP_NAME` */
export function usePageTitle() {
  useEffect(() => {
    document.title = import.meta.env.VITE_APP_NAME ?? 'Pos'
  })
}
